import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange, SimpleChanges, DoCheck, ViewChild, AfterViewChecked, AfterViewInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { of as observableOf } from 'rxjs';
import { TreeData } from './TreeData';
import { SelectionModel } from '@angular/cdk/collections';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
const files = [

  {
    name: 'angularjs',
    type: 'any',
    value: 'any',
    children: [
      { name: 'gulpfile.js', type: '', value: 's' },
      { name: 'README.md', type: '', value: 's' }
    ]
  }
];



export interface TreeNode {
  name: string;
  type: string;
  level: number;
  expandable: boolean;
}


@Component({
  selector: 'app-sidebar-filter',
  templateUrl: './sidebar-filter.component.html',
  styleUrls: ['./sidebar-filter.component.scss']
})
export class SidebarFilterComponent implements OnInit, AfterViewChecked {

  treeControl: FlatTreeControl<TreeNode>;
  treeFlattener: MatTreeFlattener<TreeData, TreeNode>;
  dataSource: MatTreeFlatDataSource<TreeData, TreeNode>;
  checklistSelection = new SelectionModel<any>(true);

  @Output() onCheckBoxClicked = new EventEmitter();
  @Input() roles
  @Input() grades: [];
  @Input() classes: [];
  @Input() count;
  @ViewChild('tree') tree;
  currLang;

  constructor(
    private globalService: GlobalService,
    private translate: TranslateService,
  ) {
    this.globalService.getLang().subscribe(lng =>{
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren);

    this.treeControl = new FlatTreeControl<TreeNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  }




  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng =>{
      this.currLang = lng;
      this.translate.use(this.currLang);
      

    });
    this.dataSource.data = this.roles;
  }
  ngAfterViewChecked() {
    // this.dataSource.data = this.roles;
    this.tree.treeControl.expand(this.treeControl.dataNodes[0]);
  }

  transformer(node: TreeData, level: number) {
    return {
      name: node.name,
      id:node.id,
      type: node.type,
      parent: node.parent,
      value: node.value,
      role: node.role || null,
      level: level,
      disabled: node.disabled,
      expandable: !!node.children
    };
  }
  

  /** Get the level of the node */
  getLevel(node: TreeNode) {
    return node.level;
  }

  /** Return whether the node is expanded or not. */
  isExpandable(node: TreeNode) {
    return node.expandable;
  };

  /** Get the children for the node. */
  getChildren(node: TreeData) {
    return observableOf(node.children);
  }

  /** Get whether the node has children or not. */
  hasChild(index: number, node: TreeNode) {
    return node.expandable;
  }


  checkAllParentsSelection(node: any): void {
    let parent: any | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }
  checkRootNodeSelection(node: any): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: any): any | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }
  descendantsPartiallySelected(node: any): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: any): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
    return descAllSelected && (descendants.length!=0);
  }

  uncheckNodes(type) {
    this.treeControl.dataNodes.filter(node => node.type == type).forEach(node => {
      this.checklistSelection.isSelected(node) ? this.checklistSelection.deselect(node) : console.log('')
    })
  }

  todoItemSelectionToggle(node: any): void {
    if (node.name == 'Roles') return

    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node).filter((x: any) => x.disabled == false)
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);
    this.onCheckBoxClicked.emit(this.checklistSelection.selected);

  }
  todoLeafItemSelectionToggle(node: any): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
    
    switch (node.name) {
      // adding arabic cases fixed Gates, Routes, Grades can't be selected when using the Arabic Language bug
      case "Drivers":
        this.uncheckNodes('route_name')
        this.treeControl.dataNodes.filter((x: any) => x.parent == "drivers").map((x: any) => x.disabled = !x.disabled);
        break;
        case "السائقين": 
        this.uncheckNodes('route_name')
        this.treeControl.dataNodes.filter((x: any) => x.parent == "drivers").map((x: any) => x.disabled = !x.disabled);
        break;

      case "Teachers":
        this.uncheckNodes('class_name')
        this.uncheckNodes('grade_name')
        const isParentChecked1 = this.checklistSelection.selected.some(checked => checked['parent'] == "parentParent");
        const isSupervisorsChecked1 = this.checklistSelection.selected.some(checked => checked['parent'] == "supervisorsParent");
        if (isSupervisorsChecked1 || isParentChecked1) {
          this.treeControl.dataNodes.filter((x: any) => x.parent == "classes").map((x: any) => x.disabled = !x.disabled);

        } else {
          this.treeControl.dataNodes.filter((x: any) => x.parent == "gradesParent" || x.parent == "grades" || x.parent == "classes")
            .map((x: any) => x.disabled = !x.disabled)
          this.treeControl.dataNodes.filter((x: any) => x.parent == "grades")
        }
        break;
        case "المعلمين":
        this.uncheckNodes('class_name')
        this.uncheckNodes('grade_name')
        const isParentChecked2 = this.checklistSelection.selected.some(checked => checked['parent'] == "parentParent");
        const isSupervisorsChecked3 = this.checklistSelection.selected.some(checked => checked['parent'] == "supervisorsParent");
        if (isSupervisorsChecked3 || isParentChecked2) {
          this.treeControl.dataNodes.filter((x: any) => x.parent == "classes").map((x: any) => x.disabled = !x.disabled);

        } else {
          this.treeControl.dataNodes.filter((x: any) => x.parent == "gradesParent" || x.parent == "grades" || x.parent == "classes")
            .map((x: any) => x.disabled = !x.disabled)
          this.treeControl.dataNodes.filter((x: any) => x.parent == "grades")
        }
        break;

      case "Parents":
        this.uncheckNodes('class_name')
        this.uncheckNodes('grade_name')
        const isTeachersChecked2 = this.checklistSelection.selected.some(checked => checked['parent'] == "teacherParent");
        const isSupervisorsChecked2 = this.checklistSelection.selected.some(checked => checked['parent'] == "supervisorsParent");
        if (!(isTeachersChecked2 || isSupervisorsChecked2)) {
          this.treeControl.dataNodes.filter((x: any) => x.parent == "gradesParent" || x.parent == "grades" || x.parent == "classes")
            .map((x: any) => x.disabled = !x.disabled)
          this.treeControl.dataNodes.filter((x: any) => x.parent == "grades")

        }
        break;

        case "الآباء":
          this.uncheckNodes('class_name')
          this.uncheckNodes('grade_name')
          const isTeachersChecked4 = this.checklistSelection.selected.some(checked => checked['parent'] == "teacherParent");
          const isSupervisorsChecked5 = this.checklistSelection.selected.some(checked => checked['parent'] == "supervisorsParent");
          if (!(isTeachersChecked4 || isSupervisorsChecked5)) {
            this.treeControl.dataNodes.filter((x: any) => x.parent == "gradesParent" || x.parent == "grades" || x.parent == "classes")
              .map((x: any) => x.disabled = !x.disabled)
            this.treeControl.dataNodes.filter((x: any) => x.parent == "grades")
  
          }
          break;
  

      case "Supervisors":
        this.uncheckNodes('class_name')
        this.uncheckNodes('grade_name')
        const isParentChecked3 = this.checklistSelection.selected.some(checked => checked['parent'] == "parentParent");
        const isTeachersChecked3 = this.checklistSelection.selected.some(checked => checked['parent'] == "teacherParent");
        if (!(isTeachersChecked3 || isParentChecked3)) {
          this.uncheckNodes('grade_name')
          this.treeControl.dataNodes.filter((x: any) => x.parent == "gradesParent").map((x: any) => (x.disabled = !x.disabled))
          this.treeControl.dataNodes.filter((x: any) => x.parent == "grades").map((x: any) => x.disabled = !x.disabled)
        }
        break;

        case "المشرفين":
        this.uncheckNodes('class_name')
        this.uncheckNodes('grade_name')
        const isParentChecked4 = this.checklistSelection.selected.some(checked => checked['parent'] == "parentParent");
        const isTeachersChecked6 = this.checklistSelection.selected.some(checked => checked['parent'] == "teacherParent");
        if (!(isTeachersChecked6 || isParentChecked4)) {
          this.uncheckNodes('grade_name')
          this.treeControl.dataNodes.filter((x: any) => x.parent == "gradesParent").map((x: any) => (x.disabled = !x.disabled))
          this.treeControl.dataNodes.filter((x: any) => x.parent == "grades").map((x: any) => x.disabled = !x.disabled)
        }
        break;
      case "Security":
        this.uncheckNodes('gates')
        this.treeControl.dataNodes.filter((x: any) => x.parent == "security").map((x: any) => x.disabled = !x.disabled)
        break;

        case "الحارس":
        this.uncheckNodes('gates')
        this.treeControl.dataNodes.filter((x: any) => x.parent == "security").map((x: any) => x.disabled = !x.disabled)
        break;

      case "Shared Gate":
        this.uncheckNodes('gates')
        this.treeControl.dataNodes.filter((x: any) => x.parent == "security").map((x: any) => x.disabled = !x.disabled)
        break;

      case "بوابة مشتركة":
        this.uncheckNodes('gates')
        this.treeControl.dataNodes.filter((x: any) => x.parent == "security").map((x: any) => x.disabled = !x.disabled)
        break;

    }
    this.onCheckBoxClicked.emit(this.checklistSelection.selected);


  }
  

}
